import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import * as correspondentOnboardingAction from './action';
import { CORE_API } from '../../../config';

export function* fetchCorrespondentEntity(action) {
    let requestUrl = `${CORE_API}/correspondent/entity/${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(correspondentOnboardingAction.fetchCorrespondentEntityDetailsSuccess(createResult));
    } catch (err) {
        yield put(correspondentOnboardingAction.fetchCorrespondentEntityDetailsFailure(err))
    }
}

export function* fetchCorrespondentEntityDetails() {
    yield takeLatest(correspondentOnboardingAction.FETCH_CORRESPONDENT_ENTITY_DETAILS, fetchCorrespondentEntity);
}


export function* createCorrespondent(action) {
    let requestUrl = `${CORE_API}/correspondent/onboarding/create`;
    try {
        const createResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(correspondentOnboardingAction.createCorrespondentEntitySuccess(createResult));
    } catch (err) {
        yield put(correspondentOnboardingAction.createCorrespondentEntityFailure(err))
    }
}

export function* createCorrespondentEntityDetails() {
    yield takeLatest(correspondentOnboardingAction.CREATE_CORRESPONDENT_ENTITY, createCorrespondent);
}

export function* editCorrespondent(action) {
    let requestUrl = `${CORE_API}/correspondent/entity/edit`;
    try {
        const createResult = yield call(request, requestUrl, { data: action.data, method: 'PUT', headers: HTTP_HEADERS });
        yield put(correspondentOnboardingAction.editCorrespondentEntitySuccess(createResult));
    } catch (err) {
        yield put(correspondentOnboardingAction.editCorrespondentEntityFailure(err))
    }
}

export function* editCorrespondentEntity() {
    yield takeLatest(correspondentOnboardingAction.EDIT_CORRESPONDENT_ENTITY, editCorrespondent);
}